import { faUserTie } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { AppRulesContext } from "../App";
import { appConstants } from "../config/app-constants";
import { useAppSelector } from "../redux/Store";
import { ITRFilingSelector } from "../redux/slice/ITRFilingSlice";
import FASvgIcon from "./FASvgIcon";
import GuardedComponent from "./GuardedComponent";

const GetExpertCard: React.FC = () => {
	const { rulesSvc } = useContext(AppRulesContext);
	const { currentFilingUUID } = useAppSelector(ITRFilingSelector);
	// const minPlanAmount = useAppSelector(MinPlansAmountSelector);

	const navigate = useNavigate();

	return (
		<>
			<Card bg="greyDefault" className="get-expert-card">
				<Card.Img
					variant="top"
					src={`${appConstants.basePath}/assets/images/get-an-expert.svg`}
					className="img-fluid bg-transparent"
					alt="Get Expert"
				/>
				<Card.Body>
					<h3 className="fw-bold text-primary">Need assistance to file Income Tax Return?</h3>
					<p className="mt-3 mb-5">
						Hire an expert to do your taxes equipped with end-to-end online fulfillment. No hassle.
						100% digital.
					</p>
					<GuardedComponent rules={rulesSvc.userPlanList} behavior="hide">
						<>
							<Button
								variant="primary"
								size="sm"
								className="mb-3 w-100"
								onClick={() =>
									navigate(`/itr-filings/${currentFilingUUID}/assisted/plans`, {
										state: { sourceScreen: "assisted" }
									})
								}
							>
								<FASvgIcon icon={faUserTie} />
								{/* {currentFilingData && currentFilingData?.EfilingPlans?.length > 0
                  ? "Upgrade Plan"
                  : "Get Expert Assistance"} */}
								Get Expert Assistance
							</Button>
							{/* TODO: commented as per client discussion */}
							{/* {minPlanAmount ? (
								<p className="leading-para text-greyDark mb-0">
									Starting from <PriceDisplay price={minPlanAmount} />
								</p>
							) : null} */}
						</>
					</GuardedComponent>
				</Card.Body>
			</Card>
		</>
	);
};

export default GetExpertCard;
